// استان‌های ایران + مرکزِ نقشه (مرکزِ استان) — مشترک بینِ نوارِ بالا (فیلترِ اکسپلور) و فرمِ آگهی (انتخابِ
// استان قبل از لوکیشن). همین فهرست در سرور هم هست (designs/index.js) — هر تغییری هر دو جا انجام شود
export const PROVINCES = [
  { name: 'آذربایجان شرقی', center: [38.08, 46.29] },
  { name: 'آذربایجان غربی', center: [37.55, 45.07] },
  { name: 'اردبیل', center: [38.25, 48.29] },
  { name: 'اصفهان', center: [32.65, 51.67] },
  { name: 'البرز', center: [35.84, 50.94] },
  { name: 'ایلام', center: [33.64, 46.42] },
  { name: 'بوشهر', center: [28.97, 50.84] },
  { name: 'تهران', center: [35.69, 51.39] },
  { name: 'چهارمحال و بختیاری', center: [32.33, 50.86] },
  { name: 'خراسان جنوبی', center: [32.87, 59.22] },
  { name: 'خراسان رضوی', center: [36.3, 59.61] },
  { name: 'خراسان شمالی', center: [37.47, 57.33] },
  { name: 'خوزستان', center: [31.32, 48.67] },
  { name: 'زنجان', center: [36.67, 48.48] },
  { name: 'سمنان', center: [35.58, 53.39] },
  { name: 'سیستان و بلوچستان', center: [29.5, 60.86] },
  { name: 'فارس', center: [29.59, 52.58] },
  { name: 'قزوین', center: [36.27, 50.0] },
  { name: 'قم', center: [34.64, 50.88] },
  { name: 'کردستان', center: [35.31, 47.0] },
  { name: 'کرمان', center: [30.28, 57.08] },
  { name: 'کرمانشاه', center: [34.31, 47.07] },
  { name: 'کهگیلویه و بویراحمد', center: [30.67, 51.59] },
  { name: 'گلستان', center: [36.84, 54.43] },
  { name: 'گیلان', center: [37.28, 49.58] },
  { name: 'لرستان', center: [33.49, 48.36] },
  { name: 'مازندران', center: [36.56, 53.06] },
  { name: 'مرکزی', center: [34.09, 49.69] },
  { name: 'هرمزگان', center: [27.18, 56.27] },
  { name: 'همدان', center: [34.8, 48.51] },
  { name: 'یزد', center: [31.9, 54.36] },
];

export const PROVINCE_NAMES = PROVINCES.map((p) => p.name);
export const ALL_PROVINCES = 'همه‌ی ایران';

export function provinceCenter(name) {
  const p = PROVINCES.find((x) => x.name === name);
  return p ? p.center : null;
}
